module.exports = __webpack_public_path__ + "assets/img/fengmodianzu.4015145a.jpg";